import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import gift from "../../../images/newDesign/gift.svg";
import allBuildings from "../../../images/newDesign/all_buildings.svg";
import products_at_discount from "../../../images/newDesign/products_at_discount.svg";
import { MenuNavItem } from "../../sidebar/MenuNavItem";
import { isLinkActive } from "../../sidebar/Sidebar.shared";
import MaintenanceSidebarMenu from "./maintenanceSidebarMenu";
import { constants } from "../../../common/constants/constants";
import { shouldHideRewardsSelector } from "../../../store/auth/selectors";
import { toggleMobileMenuOpened } from "../../../store/common/slice";
import integration from "../../../images/newDesign/integration.svg";

/**
 * @param {string} buildingId
 * @param {boolean} isGreenInvoiceOn
 * @return {JSX.Element}
 * @constructor
 */
export default function PartnerSidebarGroup({ buildingId, isGreenInvoiceOn }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const shouldHideRewards = useSelector(shouldHideRewardsSelector);
    const userProfile = useSelector((state) => state.auth.userProfile);

    const closeSidebarOnMobileClick = () => {
        dispatch(toggleMobileMenuOpened())
    }

    return (
        <Fragment>
            {!shouldHideRewards && (
                <MenuNavItem
                    icon={gift}
                    url={`/${constants.pages.rewards}`}
                    onClick={closeSidebarOnMobileClick}
                    label={t('buildings.nav_bar_rewards')}
                />

            )}
            <MenuNavItem
                icon={products_at_discount}
                url={`/${constants.pages.productsAtDiscountUrl}`}
                onClick={closeSidebarOnMobileClick}
                label={t('buildings.nav_bar_products_at_a_discount')}
            />
            <MaintenanceSidebarMenu buildingId={buildingId}/>
            <MenuItem
                icon={<img src={allBuildings} alt="MC dashboard"/>}
                active={isLinkActive(`/${constants.pages.buildingManagerCompanyProfileUrl}/:partnerID`)}
                onClick={closeSidebarOnMobileClick}>
                <NavLink
                    className="nav-link"
                    to={`/${constants.pages.buildingManagerCompanyProfileUrl}/${userProfile.partnerID}`}>
                    {t('buildings.nav_bar_all_buildings_data')}
                </NavLink>
            </MenuItem>
            {isGreenInvoiceOn && (
                <MenuItem icon={<img src={integration} alt="integration"/>}>
                    <NavLink
                        className="dropdown-link"
                        to={{ pathname: `https://auth.greeninvoice.co.il/signin` }} target="_blank">
                        {t('reports.accounting_service')}
                    </NavLink>
                </MenuItem>
            )}
        </Fragment>
    );
}
